export default __webpack_public_path__ + "static/Entenda0091-7b2e6ec2bafbcfa2de0b1d00923622db.jpg";